import React, { useEffect, useState } from "react";

// MUI
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  TextField,
} from "@material-ui/core";

// Icons
import CategoryRoundedIcon from "@material-ui/icons/CategoryRounded";
import AppIcon from "@material-ui/icons/DonutSmallRounded";
import SmartAppIcon from "@material-ui/icons/SmartphoneRounded";
import AdIcon from "@material-ui/icons/LoupeRounded";
import ClassIcon from "@material-ui/icons/ClassRounded";
import ProductIcon from "@material-ui/icons/Loyalty";

import { getDashboardCounts } from "../db";
import DashboardCounter from "../components/DashboardCounter";

const useStyles = makeStyles((theme) => ({
  fieldRow: {
    margin: "10px 0",
  },
}));

const Home = () => {
  const classes = useStyles();

  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    image: "",
  });

  const [errors, setErrors] = useState({
    title: "",
    description: "",
    image: "",
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setData(await getDashboardCounts());
  };

  const handleClose = () => setOpen(false);

  const handleInputChange = (e) => {
    setErrors({
      ...errors,
      [e.target.name]: e.target.value === "" ? "Invalid value!" : "",
    });

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (errors.title !== "" || errors.description !== "" || errors.image !== "")
      return;

    console.log("oay");
  };

  return (
    <Grid container alignItems="center" component={Box} mt={5}>
      <Grid item sm={12} md={6}>
        <DashboardCounter
          title="Categories"
          icon={CategoryRoundedIcon}
          number={data.categories}
          color="primary"
        />
      </Grid>
      <Grid item sm={12} md={6}>
        <DashboardCounter
          title="Apps"
          icon={AppIcon}
          number={data.apps}
          color="error"
        />
      </Grid>
      <Grid item sm={12} md={6}>
        <DashboardCounter
          title="Smart Apps"
          icon={SmartAppIcon}
          number={data.smartapps}
          color="warning"
        />
      </Grid>
      <Grid item sm={12} md={6}>
        <DashboardCounter
          title="Product Category"
          icon={ClassIcon}
          number={data.productCategories}
          color="success"
        />
      </Grid>
      <Grid item sm={12} md={6}>
        <DashboardCounter
          title="Product"
          icon={ProductIcon}
          number={data.products}
          color="error"
        />
      </Grid>
      <Grid item sm={12} md={6}>
        <DashboardCounter
          title="Advertisements"
          icon={AdIcon}
          number={data.advertisements}
          color="info"
        />
      </Grid>
      <Dialog fullWidth maxWidth="sm" onClose={handleClose} open={open}>
        <DialogTitle>Send a notification!</DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                <TextField
                  className={classes.fieldRow}
                  value={formData.title}
                  onChange={handleInputChange}
                  error={errors.title ? true : false}
                  helperText={errors.title}
                  label="Title"
                  name="title"
                />
                <TextField
                  className={classes.fieldRow}
                  value={formData.description}
                  onChange={handleInputChange}
                  error={errors.description ? true : false}
                  helperText={errors.description}
                  label="Description"
                  name="description"
                />
                <TextField
                  className={classes.fieldRow}
                  value={formData.image}
                  onChange={handleInputChange}
                  error={errors.image ? true : false}
                  helperText={errors.image}
                  label="Image URL"
                  name="image"
                  type="url"
                />
              </div>

              {formData.image && (
                <div style={{ margin: 10, textAlign: "center", width: "100%" }}>
                  <img
                    style={{
                      width: 100,
                      height: 100,
                      textAlign: "center",
                      objectFit: "cover",
                      borderRadius: 5,
                    }}
                    id="notificationImage"
                    src={formData.image}
                    alt="notificationImage"
                    onError={(ev) =>
                      setErrors({ ...errors, image: "Wrong URL" })
                    }
                  />
                </div>
              )}
            </div>
            <div style={{ textAlign: "end" }}>
              <Button type="submit" variant="contained" color="primary">
                Submit
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default React.memo(Home);
